//region block: pre-declaration
//endregion
function recoverStackTrace(exception, continuation) {
  return exception;
}
function unwrap(exception) {
  return exception;
}
//region block: exports
export {
  recoverStackTrace as recoverStackTrace2i3si2i8nvw1k,
  unwrap as unwrap34f7x4f5snsxt,
};
//endregion

//# sourceMappingURL=StackTraceRecovery.mjs.map
